import React, { useEffect, useState } from 'react'
import { Checkbox, CheckboxGroup, Col, Message, Panel, Radio, RadioGroup, Rate, Row } from 'rsuite'
import InputForm from '../../components/forms/input/InputForm'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import moment from 'moment'
import { isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import InputSelectForm from '../../components/forms/input/InputSelectForm'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import MAndEWorkerForm from './MAndEWorkerForm'
import { DATE_FORMAT, DATE_PICKER_FORMAT } from '../../constants/date'
import PopoverMessages from '../../components/message/PopoverMessages'
import { cloneDeep, isEmpty } from 'lodash-es'
import { loadLocation } from '../../components/location/Location'
import InputMultiCascaderForm from '../../components/forms/input/InputMultiCascaderForm'
import InputCascaderForm from '../../components/forms/input/InputCascaderForm'
import MAndEProjectInfo from './MAndEProjectInfo'

export default function MAndEForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  ...props
}) {
  const [formSchema, setFormSchema] = useState(_schema)
  const [startDate, setStartDate] = useState(
    _schema.startDate.value
      ? moment(_schema.startDate.value, DATE_FORMAT).toDate()
      : moment(_schema.projectStartDate, DATE_FORMAT).toDate()
  )
  const [endDate, setEndDate] = useState(
    _schema.endDate.value
      ? moment(_schema.endDate.value, DATE_FORMAT).toDate()
      : moment(_schema.projectEndDate, DATE_FORMAT).toDate()
  )

  const [delWorkerId, setDelWorkerId] = useState([])
  const [workerData, setWorkerData] = useState(_schema?.workingGroup?.values || [])
  const [result, setResult] = useState(new Map())
  const [location, setLocation] = useState([])
  const [uncheckableItems, setUncheckableItems] = useState([])
  const [answers, setAnswers] = useState(0)

  useEffect(() => {
    let rs = new Map()
    let assessment = _schema?.assessment?.datas || []
    let datas = appendAssessmentResult(assessment)

    datas?.forEach((e) => {
      rs.set(e.questionId, e.value)
    })

    if (isLocation(assessment)) {
      handleLocation()
    }

    setResult(rs)
    onSetAnswers(Array.from(rs.keys()))
    setValue('assessmentResult', rs)
  }, [_schema])

  const handleLocation = async () => {
    // setLoading(true)
    let locationJson = await loadLocation()

    // let uncheckables = extractUncheckableItems(locationJson || [])
    // console.log('uncheckables : ', uncheckables)

    setLocation(locationJson || [])
    // setUncheckableItems(uncheckables || [])
    // setLoading(false)
  }

  // const extractUncheckableItems = (datas) => {
  //   const results = []

  //   datas?.forEach((e) => {
  //     if (Array.isArray(e.children)) {
  //       results.push(e.value)
  //       results.push(...extractUncheckableItems(e.children))
  //     }
  //   })

  //   return results
  // }

  const isLocation = (datas) => {
    var result = []

    var obj = datas?.find((e) => ['7', '8'].includes(e.selection?.type))

    if (obj) {
      return true
    } else {
      for (let item of datas) {
        if (item.children?.length > 0) {
          var childResult = isLocation(item.children)
          if (childResult) {
            return childResult
          }
        }

        return false
      }
    }

    return result
  }

  const onSetAnswers = (arr) => {
    const { groups, counts } = countTheAnswers(arr)

    setAnswers(
      Object.entries(counts)
        ?.filter(([key, count]) => count === 4)
        ?.map(([key]) => key)?.length
    )
  }

  const onChange = (key, value) => {
    let rs = cloneDeep(result)
    if (value == null || value?.length === 0) {
      setValue(key, '')
      rs.delete(key)
    } else {
      rs.set(key, value + '')
    }

    setResult(rs)
    onSetAnswers(Array.from(rs.keys()))
    setValue('assessmentResult', rs)
  }

  const appendAssessmentResult = (datas) => {
    var result = []

    for (let item of datas) {
      if (item.selection && !isEmpty(item.selection.type)) {
        if (!isEmpty(item.selection.value)) {
          result.push({
            //id: item.id,
            questionId: item.selection.name,
            value: Array.isArray(item.selection.value)
              ? item.selection.value.join(',')
              : item.selection.value,
          })
        }

        if (!isEmpty(item.qualitativeData.value)) {
          result.push({
            //id: item.id,
            questionId: `${item.qualitativeData.name}_${item.selection.name}`,
            value: item.qualitativeData.value,
          })
        }

        if (!isEmpty(item.evaluationTeamReflect.value)) {
          result.push({
            //id: item.id,
            questionId: `${item.evaluationTeamReflect.name}_${item.selection.name}`,
            value: item.evaluationTeamReflect.value,
          })
        }

        if (!isEmpty(item.change.value)) {
          result.push({
            //id: item.id,
            questionId: `${item.change.name}_${item.selection.name}`,
            value: item.change.value,
          })
        }
      }

      if (item.children?.length > 0) {
        var childResult = appendAssessmentResult(item.children)
        if (childResult.length > 0) {
          result.push(...childResult)
        }
      }
    }

    return result
  }

  const renderAssessment = (datas, isTab) => {
    return (
      <>
        {datas?.map((data, index) => {
          return (
            <Panel
              bordered
              key={data.id}
              style={{
                marginTop: isTab ? -10 : 10,
                marginLeft: isTab ? 10 : 0,
                marginBottom: isTab ? 20 : 10,
              }}
              collapsible
              defaultExpanded
              header={
                <div>
                  {data.selection ? (
                    <>
                      {requiredFiled(data.selection.validators, `${data.label}`)}
                      <PopoverMessages content={data.note} />
                    </>
                  ) : (
                    <>{data.label}</>
                  )}
                </div>
              }
            >
              {data.selection && (
                <div style={{ marginTop: -15 }}>
                  {data.selection.type == '1' && (
                    <>
                      <ErrorMessage error={errors[`${data.selection.name}`]} />
                      <Controller
                        name={`${data.selection.name}`}
                        control={control}
                        rules={isValidators(data.selection.validators)}
                        defaultValue={data.selection.value}
                        render={(props) => {
                          let objName = `${data.selection.name}`

                          return (
                            <RadioGroup
                              name={objName}
                              defaultValue={data.selection.value}
                              onChange={(value) => {
                                props.onChange(value)
                                onChange(data.selection.name, value)
                                if (value.length === 0) setValue(objName)
                              }}
                            >
                              {data.selection.options.map((item, index) => {
                                return (
                                  <Radio key={item.value} value={item.value}>
                                    <p
                                      dangerouslySetInnerHTML={{ __html: item.label }}
                                      style={{ marginTop: -3 }}
                                    />
                                  </Radio>
                                )
                              })}
                            </RadioGroup>
                          )
                        }}
                      />
                    </>
                  )}

                  {data.selection.type == '2' && (
                    <>
                      <ErrorMessage error={errors[`${data.selection.name}`]} />

                      <Controller
                        name={`${data.selection.name}`}
                        control={control}
                        rules={isValidators(data.selection.validators)}
                        defaultValue={data.selection.value}
                        render={(props) => {
                          let objName = `${data.selection.name}`

                          return (
                            <CheckboxGroup
                              name={objName}
                              defaultValue={data.selection.value}
                              onChange={(value) => {
                                props.onChange(value)
                                onChange(data.selection.name, value)
                                if (value.length === 0) setValue(objName)
                              }}
                            >
                              {data.selection.options.map((item, index) => {
                                return (
                                  <Checkbox key={item.value} value={item.value}>
                                    <p
                                      dangerouslySetInnerHTML={{ __html: item.label }}
                                      style={{ marginTop: -3 }}
                                    />
                                  </Checkbox>
                                )
                              })}
                            </CheckboxGroup>
                          )
                        }}
                      />
                    </>
                  )}

                  {data.selection.type == '3' && (
                    <>
                      <InputForm
                        hideLabel
                        schema={data.selection}
                        //name={`${data.selection.name}`}
                        rows={4}
                        componentClass="textarea"
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        onChange={(value) => {
                          onChange(data.selection.name, value)
                        }}
                      />
                    </>
                  )}

                  {data.selection.type == '4' && (
                    <>
                      <InputForm
                        hideLabel
                        schema={data.selection}
                        //name={`${data.selection.name}`}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        onChange={(value) => {
                          onChange(data.selection.name, value)
                        }}
                      />
                    </>
                  )}

                  {data.selection.type == '5' && (
                    <>
                      <InputForm
                        hideLabel
                        isInputNumber
                        schema={data.selection}
                        //name={`${data.selection.name}`}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        onChange={(value) => {
                          onChange(data.selection.name, value)
                        }}
                      />
                    </>
                  )}

                  {data.selection.type == '6' && (
                    <>
                      <ErrorMessage error={errors[`${data.selection.name}`]} />

                      <Controller
                        name={`${data.selection.name}`}
                        control={control}
                        rules={isValidators(data.selection.validators)}
                        defaultValue={data.selection.value}
                        render={(props) => {
                          return (
                            <Row style={{ textAlign: 'center' }}>
                              <Rate
                                defaultValue={data.selection.maximum / 2}
                                max={data.selection.maximum}
                                classPrefix="rs-rate rs-rate-size-xl"
                                //value={data.selection.value || 0}
                                onChange={(value) => {
                                  props.onChange(value)
                                  onChange(data.selection.name, value)
                                }}
                              />
                            </Row>
                          )
                        }}
                      />
                    </>
                  )}

                  {data.selection.type == '7' && (
                    <>
                      <InputCascaderForm
                        hideLabel
                        schema={data.selection}
                        name={data.selection.name}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        cascaderDatas={location}
                        onChange={(value) => {
                          onChange(data.selection.name, value)
                        }}
                      />
                    </>
                  )}
                  {data.selection.type == '8' && (
                    <>
                      <InputMultiCascaderForm
                        hideLabel
                        schema={data.selection}
                        name={data.selection.name}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        cascaderDatas={location}
                        uncheckableItems={uncheckableItems}
                        onChange={(value) => {
                          onChange(data.selection.name, value)
                        }}
                      />
                    </>
                  )}

                  {data.qualitativeData && (
                    <>
                      <InputForm
                        schema={data.qualitativeData}
                        name={`${data.qualitativeData.name}_${data.selection.name}`}
                        rows={4}
                        componentClass="textarea"
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        onChange={(value) => {
                          onChange(`${data.qualitativeData.name}_${data.selection.name}`, value)
                        }}
                      />
                    </>
                  )}
                  {data.evaluationTeamReflect && (
                    <>
                      <InputForm
                        schema={data.evaluationTeamReflect}
                        name={`${data.evaluationTeamReflect.name}_${data.selection.name}`}
                        rows={4}
                        componentClass="textarea"
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        onChange={(value) => {
                          onChange(
                            `${data.evaluationTeamReflect.name}_${data.selection.name}`,
                            value
                          )
                        }}
                      />
                    </>
                  )}
                  {data.change && (
                    <>
                      <InputForm
                        schema={data.change}
                        name={`${data.change.name}_${data.selection.name}`}
                        rows={4}
                        componentClass="textarea"
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        onChange={(value) => {
                          onChange(`${data.change.name}_${data.selection.name}`, value)
                        }}
                      />
                    </>
                  )}
                </div>
              )}

              {data.children?.length > 0 && renderAssessment(data.children, true)}
            </Panel>
          )
        })}
      </>
    )
  }

  const onDeleteWorker = (id) => {
    let delIds = [...delWorkerId, id]

    setDelWorkerId(delIds)

    setValue('delWorkerId', delIds)
  }

  const onUpdateWorker = (data) => {
    setWorkerData(data)

    setValue('workerData', data)
  }

  const countTheAnswers = (arr) => {
    const groups = {}

    arr.forEach((item) => {
      // เอาส่วนท้ายหลัง "_" ถ้ามี เช่น "XX_A1" → "A1"
      const suffix = item.includes('_') ? item.split('_').pop() : item

      // ถ้ายังไม่มีกลุ่มนี้ → สร้างใหม่
      if (!groups[suffix]) groups[suffix] = []

      // เพิ่ม item เข้าไปในกลุ่ม
      groups[suffix].push(item)
    })

    // แปลงเป็น object ที่นับจำนวนด้วย
    const counts = Object.fromEntries(
      Object.entries(groups).map(([key, list]) => [key, list.length])
    )

    return { groups, counts }
  }

  return (
    <>
      <Controller
        key={'delWorkerId'}
        name={'delWorkerId'}
        control={control}
        defaultValue={delWorkerId}
        value={delWorkerId}
      />

      <Controller
        key={'workerData'}
        name={'workerData'}
        control={control}
        defaultValue={workerData}
        value={workerData}
      />

      <Controller
        key={'assessmentResult'}
        name={'assessmentResult'}
        control={control}
        defaultValue={result}
        value={result}
      />

      {formSchema.notes?.map((e) => {
        return (
          <Row style={{ marginBottom: 10 }}>
            <Col lg={24} md={24} sm={24} xs={24}>
              <Message
                showIcon
                type={e.type}
                description={
                  <div>
                    <b>{e.actionRole} : </b>
                    <label>{e.message || ''}</label>
                    <p>
                      <b>วันที่ : </b>
                      {e.actionDate || ''}
                    </p>
                  </div>
                }
              />
            </Col>
          </Row>
        )
      })}

      <MAndEProjectInfo schema={formSchema} />

      <Row style={{ marginTop: 10 }}>
        <Col lg={12} md={12} sm={24} xs={24}>
          <InputSelectForm
            schema={formSchema.assessmentType}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <InputForm
            schema={formSchema.reportor}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: 20 }}>
        <Col lg={12} md={12} sm={24} xs={24}>
          {formSchema.startDate.label}
          <Controller
            key={formSchema.startDate.name}
            name={formSchema.startDate.name}
            control={control}
            rules={isValidators(formSchema.startDate.validators)}
            defaultValue={
              formSchema.startDate.value
                ? moment(formSchema.startDate.value, DATE_FORMAT).toDate()
                : moment(formSchema.projectStartDate, DATE_FORMAT).toDate() //moment().startOf('day').toDate()
            }
            render={(props) => {
              return (
                <DatePickerCustom
                  {...props}
                  placement="auto"
                  value={startDate}
                  disabledDate={(date) =>
                    (formSchema.projectStartDate &&
                      moment(formSchema.projectStartDate, DATE_FORMAT).isAfter(date, new Date())) ||
                    (formSchema.projectEndDate &&
                      moment(formSchema.projectEndDate, DATE_FORMAT).isBefore(date, new Date())) ||
                    (endDate && moment(endDate).isBefore(date, new Date()))
                  }
                  onChange={(value) => {
                    setStartDate(value)
                    props.onChange(value)
                  }}
                />
              )
            }}
          />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          {formSchema.endDate.label}
          <Controller
            key={formSchema.endDate.name}
            name={formSchema.endDate.name}
            control={control}
            rules={isValidators(formSchema.endDate.validators)}
            defaultValue={
              formSchema.endDate.value
                ? moment(formSchema.endDate.value, DATE_FORMAT).toDate()
                : moment(formSchema.projectEndDate, DATE_FORMAT).toDate()
            }
            render={(props) => {
              return (
                <DatePickerCustom
                  {...props}
                  placement="auto"
                  value={endDate}
                  disabledDate={(date) =>
                    (formSchema.projectStartDate &&
                      moment(formSchema.projectStartDate, DATE_FORMAT).isAfter(date, new Date())) ||
                    (formSchema.projectEndDate &&
                      moment(formSchema.projectEndDate, DATE_FORMAT).isBefore(date, new Date())) ||
                    (startDate && moment(startDate).isAfter(date, new Date()))
                  }
                  onChange={(value) => {
                    setEndDate(value)

                    props.onChange(value)
                  }}
                />
              )
            }}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <InputSelectForm
            schema={formSchema.managementUnitType}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        </Col>
      </Row>
      <Row>
        <Col lg={24} md={24} sm={24} xs={24}>
          <InputForm
            schema={formSchema.managementUnitHead}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <InputForm
            isInputNumber
            schema={formSchema.mentorCount}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        </Col>
      </Row>

      {formSchema.workingGroup && (
        <MAndEWorkerForm
          schema={formSchema.workingGroup}
          onDeleteWorker={onDeleteWorker}
          onUpdateWorker={onUpdateWorker}
        />
      )}

      <Row>
        <Col>
          <b>{formSchema.assessment.header}</b>
        </Col>
      </Row>

      {renderAssessment(formSchema.assessment.datas || [], false)}

      <Row style={{ textAlign: 'center' }}>
        <b>
          <label
            style={{
              color:
                // Array.from(result.keys()).filter(
                //   (key) =>
                //     !key.startsWith('qualitativeData_') &&
                //     !key.startsWith('evaluationTeamReflect_') &&
                //     !key.startsWith('change_')
                // ).length
                (answers || 0) == formSchema.assessment.total ? '#2da888' : '#fb8a81',
            }}
          >
            <h4>
              {
                // Array.from(result.keys()).filter(
                //   (key) =>
                //     !key.startsWith('qualitativeData_') &&
                //     !key.startsWith('evaluationTeamReflect_') &&
                //     !key.startsWith('change_')
                // ).length

                answers || 0
              }{' '}
              / {formSchema.assessment.total}
            </h4>
          </label>
        </b>
      </Row>
    </>
  )
}
